import cabinetStyle from "./MentorCabinet.module.css";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";

function PayButtonComponent(props) {

    function renderTooltip(text) {
        return (<Tooltip id="button-tooltip">
            {text}
        </Tooltip>)
    }

    return(
        <OverlayTrigger
            placement="bottom"
            delay={{show: 50, hide: 400}}
            overlay={renderTooltip(props.toolTipText)}
        >
            <div className={cabinetStyle.controlsCopy}
                 onClick={props.openOnClick}
                 >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end"
                    }}
                >
                    <div className={cabinetStyle.coinSmall}/>

                </div>
                </div>
        </OverlayTrigger>
)
}

export default PayButtonComponent;